import React, { useEffect } from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import ContactSection from "@/components/sections/ContactSection";
import useSeo from "@/hooks/useSeo";

export default function Kontakt() {
  useSeo({
    title: "Kontakt · DNA Automotive GmbH Köln | MotorWorld Köln-Rheinland",
    description: "Kontaktieren Sie DNA Automotive in Köln: Telefon, E-Mail, WhatsApp oder Kontaktformular. MotorWorld Köln-Rheinland, Butzweilerhofallee 3, 50829 Köln.",
    path: "/kontakt",
    breadcrumbs: [{ name: "Kontakt", url: "/kontakt" }],
  });
  useEffect(() => window.scrollTo(0, 0), []);

  return (
    <div className="bg-obsidian min-h-screen" data-testid="kontakt-page">
      <Header />
      <div className="pt-24">
        <ContactSection />
      </div>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
